import type { HTMLAttributes, ReactNode } from "react";
import { motion, type MotionProps } from "framer-motion";

type AnimateFadeProps = {
    show: boolean;
    children: ReactNode;
} & Omit<HTMLAttributes<HTMLDivElement>, "children"> &
    MotionProps;

const AnimateFade = (props: AnimateFadeProps) => {
    const { show, children, ...rest } = props;
    return (
        <motion.div {...rest} initial={{ opacity: 1 }} animate={{ opacity: show ? 1 : 0 }} transition={{ duration: 1 }}>
            {children}
        </motion.div>
    );
};

export default AnimateFade;
